"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopUp = void 0;
const react_1 = __importDefault(require("react"));
const PopUp_elements_1 = require("./PopUp.elements");
const classnames_1 = __importDefault(require("classnames"));
const PopUp = ({ open = true, title, description, children, onClose, className, isUseStopPropogation = true }) => {
    return (react_1.default.createElement(PopUp_elements_1.PopUpWrap, { className: (0, classnames_1.default)({ open: open }, className), onClick: onClose },
        react_1.default.createElement(PopUp_elements_1.Body, { onClick: (e) => isUseStopPropogation ? e.stopPropagation() : () => { } },
            react_1.default.createElement(PopUp_elements_1.Head, null,
                react_1.default.createElement(PopUp_elements_1.Title, null, title),
                description && (react_1.default.createElement(PopUp_elements_1.DescriptionIcon, null,
                    "?",
                    react_1.default.createElement(PopUp_elements_1.Tooltip, null, description))),
                react_1.default.createElement(PopUp_elements_1.CloseButton, { onClick: onClose })),
            react_1.default.createElement(PopUp_elements_1.Content, null, children))));
};
exports.PopUp = PopUp;
